import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Gtp } from './shared/gtp';
import { Constant } from './shared/constant';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: `./app.component.html`,
  styleUrls: [`./app.component.scss`]
})

export class AppComponent implements OnInit {

  constructor(
    private gtp: Gtp,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private constant: Constant,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
  ) {
    angulartics2GoogleAnalytics.startTracking();
    const navEndEvent$ = router.events.pipe(filter(e => e instanceof NavigationEnd));
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'UA-163856106-1', { 'page_path': e.urlAfterRedirects }); //gtag added here
    });
  }

  ngOnInit(): void {
    // Establecer el título base de la aplicación desde la información centralizada
    this.setBaseTitle();
    this.getTitlePage();
  }

  /**
   * Establece el título base de la aplicación usando la información centralizada
   */
  setBaseTitle(): void {
    const baseTitle = this.constant.titulo.replace(' : Rastreo GTP', ''); // Remover duplicado si existe
    document.title = this.constant.titulo;
  }

  /**
   * Trae el titulo configurado en la ruta dentro de data para el meta title.
   */
  getTitlePage() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd),
        map(() => this.activeRoute), map((route) => {
          while (route.firstChild) { route = route.firstChild }
          return route;
        }),
        mergeMap((route) => route.data))
      .subscribe((event) => {
        if (event.title) {
          this.gtp.setTitle(event.title);
        } else {
          // Si no hay título específico de ruta, usar el título base centralizado
          const baseTitle = this.constant.titulo.replace(' : Rastreo GTP', '');
          document.title = this.constant.titulo;
        }
      });
  }

}
